import React from 'react';
import { AddIcon } from '../../../../components/Icons/AddIcon';
import { SearchIcon } from '../../../Users/components/Table/icons/SearchIcon';

export const TeamsTable: React.FC = (): JSX.Element => {
  return (
    <div className="table">
      <div className="table__controls">
        <div className="table__controls-left">
          <AddIcon tooltipText="Add new team" onClick={() => {}} />
        </div>
        <SearchIcon />
      </div>
    </div>
  );
};
